<template>
  <client-only>
    <div class="layout-wrapper wasabi-page" :class="isNotHomePage && 'min-[5000px]:hidden'">
      <img class="layout-bg mobile-bg" :class="isCategoriesPage && '!block'" src="@/assets/images/wasabi/background.png" />
      <img class="layout-bg desktop-bg" :class="isCategoriesPage && '!hidden'" src="/images/background-for-desktop.png" />
      <div class="shadow"></div>
      <WasabiAlerty />
      <WasabiOrderEditPopup
        v-if="orderEditLog"
        :order-edit-log="orderEditLog"
        @close="$emit('close-order-edit-log')"
      />
      <NuxtPage />
    </div>
    <div v-if="isNotHomePage" class="hidden min-[5000px]:flex h-screen justify-center items-center">
      <h1 class="text-3xl">{{ $t("bigDescText") }}</h1>
    </div>
  </client-only>
</template>


<script setup lang="ts">
import { computed } from 'vue'

defineProps<{
  orderEditLog?: any | null
}>()

defineEmits<{
  (event: 'close-order-edit-log'): void
}>()

const route = useRoute()
const isNotHomePage = computed(() => {
  if (!route.path) return true;
  const pathStr = String(route.path);
  
  if (pathStr.includes('privacy-policy') || pathStr.includes('terms-of-use')) return true;
  return route.name && !String(route.name).startsWith('index');
})

const isCategoriesPage = computed(() => {
  return route.name?.toString().startsWith('categories') || route.path.includes('categories')
})
</script>

<style lang="scss" scoped>
.layout-wrapper {
  min-height: 100vh;
  z-index: 1;
  position: relative;
  overflow: hidden;
}

.layout-bg {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: -2;
  object-fit: cover;
  opacity: 0.8;
}

.desktop-bg {
  display: none;
}

@media (min-width: 1024px) {
  .mobile-bg {
    display: none;
  }
  .desktop-bg {
    display: block;
    opacity: 1;
  }
}

.shadow {
  background: radial-gradient(
    50% 50% at 50% 50%,
    var(--color-secondary) 0%,
    rgba(117, 177, 59, 0) 100%
  );
  position: fixed;
  width: 429px;
  height: 429px;
  top: 0;
  left: 24%;
  transform: translateY(-45%) translateX(20%);
  opacity: 0.4;
  z-index: -5;
}

@media only screen and (min-width: 600px) {
  .shadow {
    width: 977px;
    height: 977px;
    top: -20%;
    left: 40%;
    transform: translateY(-50%) translateX(10%);
  }
}
</style>
